import Dexie, { type Table } from 'dexie';

export interface LocalTransaction {
  localId?: number; // Primary key for Dexie
  id: string; // This is the Google Sheets transaction ID (or a temporary one)
  productId: string;
  productName: string;
  quantity: number;
  rate: number;
  total: number;
  type: 'sale' | 'expense';
  createdAt: string;
  syncStatus: 'synced' | 'pending' | 'failed';
  cancelled?: boolean; // GST bills only — soft-delete preserves the INV serial for compliance.
  cancelledAt?: string;
}

export interface LocalProduct extends Product {
  syncStatus: 'synced' | 'pending' | 'failed';
}

export interface PendingOp {
  id?: number;
  opType: 'delete_product' | 'delete_transaction';
  targetId: string;
  createdAt: string;
}

export class DailyHisaabDB extends Dexie {
  transactions!: Table<LocalTransaction>;
  products!: Table<LocalProduct>;
  pendingOps!: Table<PendingOp>;

  constructor() {
    super('DailyHisaabDB_v2');
    this.version(2).stores({
      transactions: '++localId, id, productId, productName, type, createdAt, syncStatus',
      products: 'id, barcode, name, category, syncStatus'
    });
    this.version(3).stores({
      transactions: '++localId, id, productId, productName, type, createdAt, syncStatus',
      products: 'id, barcode, name, category, syncStatus',
      pendingOps: '++id, opType, targetId'
    });
  }
}

export const db = new DailyHisaabDB();
